"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.purchaseStatusMapper = void 0;
const enum_mapper_1 = require("../utils/enum-mapper");
const api_types_1 = require("@wix/wix-vod-constants/api-types");
const globalTypes_1 = require("../public/generated/globalTypes");
exports.purchaseStatusMapper = new enum_mapper_1.EnumMapper({
    [globalTypes_1.PurchaseStatus.INITIALIZED]: api_types_1.PaymentStatus.INITIALIZED,
    [globalTypes_1.PurchaseStatus.PENDING]: api_types_1.PaymentStatus.PENDING,
    [globalTypes_1.PurchaseStatus.ACTIVE]: api_types_1.PaymentStatus.ACTIVE,
    [globalTypes_1.PurchaseStatus.EXPIRED]: api_types_1.PaymentStatus.DECLINED,
    [globalTypes_1.PurchaseStatus.CANCELED]: api_types_1.PaymentStatus.CANCELED,
    [globalTypes_1.PurchaseStatus.REFUNDED]: api_types_1.PaymentStatus.REFUNDED,
    [globalTypes_1.PurchaseStatus.SUSPENDED]: api_types_1.PaymentStatus.SUSPENDED,
    [globalTypes_1.PurchaseStatus.FAILED]: api_types_1.PaymentStatus.FAILED,
    [globalTypes_1.PurchaseStatus.DECLINED]: api_types_1.PaymentStatus.DECLINED,
});
//# sourceMappingURL=purchase-status.js.map